module.exports = __webpack_public_path__ + "img/ex-one.cfc2cfaa.png";